import React from 'react';
import { _cs } from '@togglecorp/fujs';
import Element from '../Element/index.js';
import InputLabel from '../InputLabel/index.js';
import InputError from '../InputError/index.js';
import InputHint from '../InputHint/index.js';
import InputBorder from '../InputBorder/index.js';
import useUiModeClassName from '../../hooks/useUiModeClassName.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

function InputContainer(props) {
  const {
    className,
    label,
    labelContainerClassName,
    inputSectionClassName,
    inputContainerClassName,
    icons,
    iconsContainerClassName,
    actions,
    actionsContainerClassName,
    input,
    hintContainerClassName,
    errorContainerClassName,
    inputDescription,
    disabled,
    readOnly,
    hint,
    error,
    inputSectionRef,
    invalid,
    containerRef,
    uiMode,
    filled,
    children,
    variant = 'form'
  } = props;
  const uiModeClassName = useUiModeClassName(uiMode, styles.light, styles.dark);
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: _cs(className, styles.inputContainer, uiModeClassName, disabled && styles.disabled, readOnly && styles.readOnly, (invalid || !!error) && styles.errored, filled && styles.filled, variant === 'general' && styles.forGeneralUse)
  }, /*#__PURE__*/React.createElement(InputLabel, {
    className: labelContainerClassName,
    uiMode: uiMode
  }, label), /*#__PURE__*/React.createElement(Element, {
    elementRef: inputSectionRef,
    className: _cs(styles.inputSection, inputSectionClassName),
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    actionsContainerClassName: actionsContainerClassName,
    actions: actions,
    childrenContainerClassName: _cs(styles.inputContainer, inputContainerClassName)
  }, input), children, /*#__PURE__*/React.createElement(InputBorder, {
    className: styles.inputSectionBorder,
    errored: !!error
  }), /*#__PURE__*/React.createElement(InputError, {
    className: errorContainerClassName
  }, error), !error && hint && /*#__PURE__*/React.createElement(InputHint, {
    className: hintContainerClassName
  }, hint), inputDescription);
}

var InputContainer$1 = genericMemo(InputContainer);

export { InputContainer$1 as default };
//# sourceMappingURL=index.js.map
